import { Subscription } from 'rxjs';
import {Component, OnInit, Input, Inject} from '@angular/core';
import { SpinnerService } from './../../services/spinner/spinner.service';
import {DOCUMENT} from '@angular/common';
import {removeElement} from './../../utils/util';

declare const document: any;

/**
 * interface
 */
export interface SpinnerConfig {
  backdrop?: string;
  spinnerText?: string;
  imageSource?: string;
}

/**
 * default
 * constant
 */
const spinnerDefaults: SpinnerConfig = {
  backdrop: 'white',
  spinnerText: 'Loading...',
  imageSource: 'assets/images/CVS-spinner.gif'
};

/**
 * author: Shoukath Mohammed
 */
@Component({
  selector: 'app-cvs-mdp-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  @Input()
  public config: SpinnerConfig;
  @Input()
  public show: boolean;
  /**
   * determine whether the spinner will show on page or not
   */
  public display = false;
  /**
   * public subcription
   */
  public subsription: Subscription;

  /**
   * constructor
   * param: {spinner<SpinnerService>}
   */
  constructor(@Inject(DOCUMENT) private _document, private spinner: SpinnerService) {
    this.initSubstription();
    removeElement(this._document.querySelector('#staticHeader'));
  }

  /**
   *  method<life cycle hook>
   */
  public ngOnInit(): void {
    // setTimeout(() => {
      this.config = Object.assign({},
        spinnerDefaults, (this.config || {})
      );
    // }, 50);
    this.spinner.display$.subscribe((val: boolean) => {
      this.display = val;
      if (window.scrollY > 0 && val) {
        this._document.body.classList.add('body-scrolled');
      } else {
        this._document.body.classList.remove('body-scrolled');
      }
    });
  }

  /**
   * private
   * return: void
   * description: subscribes to the spinner display event.
   */
  private initSubstription(): void {
    this.subsription = this.spinner.load()
      .subscribe(value => {
        this.display = value;
        this._update();
      });
  }

  /**
   * private
   * return: void
   * @description: removes the overflow property so the
   * background cannot be accessed by the user.
   */
  private _update(): void {
   const display: boolean = this.display;
   document.documentElement.style.overflow = (display) ? 'hidden' : '';
   document.body.scroll = (display) ? 'no' : 'yes';
  }
}
